import { getCookie } from "./cookieUtils";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoginBox from "./LoginBox";
import TrackingBox from "./TrackingBox";

const Enquiry = () => {
    const inputrefs = useRef([]);
    const [loading, setLoading] = useState(false);
    const [userName, setUserName] = useState(getCookie("userName") || "");
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phoneNo: "",
        address: "",
        city: "",
        comment: "",
        enterCode: "",
        captcha: "",
    });


    const convertToNumber = (value) => {
        return value.replace(/[^0-9]/g, '');
    }
   
    const apiConfig = {
        AuthToken: "NASSKD28462RWKF35793FWEU757",
        LoginUserCode: userName,
        Source: "Web"
    };

    const handleSave = async (e) => {
        setLoading(true);
        try {
            const payload = {
                ...apiConfig,
              ...formData
            };

            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/Enquiry/SendEnquiry`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();

            if (data.status === "SUCCESS") {
                if (formData.enterCode.trim() !== formData.captcha.trim()) {
                    toast.error("Invalid security code");
                    generateCaptcha(); 
                    return;
                }
                setFormData({
                    firstName: "",
                    lastName: "",
                    email: "",
                    phoneNo: "",
                    address: "",
                    city: "",
                    comment: "",
                    enterCode: "",
                    captcha: "",
                })
                generateCaptcha();
                toast.success(data?.message);
            } else if (data.status === "ERROR") {
                toast.error(data?.message);
            }
        } catch (error) {
            console.error("Error saving user:", error);
            toast.error("Failed to save user. ");
        } finally {
            setLoading(false);
        }
    };

    const generateCaptcha = () => {
        const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
        let result = "";

        for (let i = 0; i < 5; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }

        setFormData(prev => ({
            ...prev,
            captcha: result,
            enterCode: ""  
        }));
    };


    const handleReset = () => {
        setFormData({
            firstName: "",
            lastName: "",
            email: "",
            phoneNo: "",
            address: "",
            city: "",
            comment: "",
            enterCode: "",
            captcha: "",
        })
        generateCaptcha();
    }

    useEffect(() => {
        generateCaptcha();
        inputrefs.current["txtFirstName"].focus();
    }, []);

    return (
        <>
            <section>
                <div className="container-fluid">
                    <img src="images/innerbanner.webp" className='img-fluid' alt="" />
                </div>
            </section>

            {/* MAIN SECTION */}
            <section className="main-section">
                <div className="container">
                    <div className="row g-4">

                        {/* SIDEBAR */}
                        <div className="col-lg-3">

                            <TrackingBox />
                            <LoginBox />

                            {/* Contact */}
                            <div className="contact-card">
                                <div className="contact-title">Contact</div>

                                <div className="contact-item">
                                    <div className="contact-icon phone">
                                        <i className="fa fa-phone"></i>
                                    </div>
                                    <a href="tel:01141606842">+91 96672 33072</a>
                                </div>

                                <div className="contact-item">
                                    <div className="contact-icon email">
                                        <i className="fa fa-envelope"></i>
                                    </div>
                                    <a href="#">oxford_express@yahoo.co.in</a>
                                </div>

                                <div className="contact-item">
                                    <div className="contact-icon email">
                                        <i className="fa fa-envelope"></i>
                                    </div>
                                    <a href="#">info@oxfordexp.com</a>
                                </div>
                            </div>
                        </div>

                        {/* CONTENT */}
                        <div className="col-lg-9">
                            <div className="p-4 pt-0">

                                {/* Welcome */}
                                <div className="rounded-3 mb-4">

                                    <h2 className="section-title">
                                        ENQUIRY
                                    </h2>

                                    <p className="welcome-text">
                                        Fields marked with an * are mandatory.
                                    </p>
                                </div>

                                <form>
                                    <div className="row g-3">

                                        {/* First Name */}
                                        <div className="col-md-6">
                                            <div className="login-field mb-0">
                                                <label>First Name<span className="text-danger">*</span></label>
                                                <input id="txtFirstName"
                                                    ref={(el) => (inputrefs.current["txtFirstName"] = el)}
                                                    type="text"
                                                    className="track-input"
                                                    value={formData.firstName }
                                                    placeholder="Enter first name"
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            inputrefs.current["txtLastName"]?.focus();
                                                        }
                                                    }}
                                                    onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
                                                />
                                            </div>
                                        </div>

                                        {/* Last Name */}
                                        <div className="col-md-6">
                                            <div className="login-field mb-0">
                                                <label>Last Name</label>
                                                <input id="txtLastName"
                                                    ref={(el) => (inputrefs.current["txtLastName"] = el)}
                                                    type="text"
                                                    className="track-input"
                                                    value={formData.lastName}
                                                    placeholder="Enter last name"
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            inputrefs.current["txtEmail"]?.focus();
                                                        }
                                                    }}
                                                    onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
                                                />
                                            </div>
                                        </div>

                                        {/* Email */}
                                        <div className="col-md-6">
                                            <div className="login-field mb-0">
                                                <label>E-mail<span className="text-danger">*</span></label>
                                                <input id="txtEmail"
                                                    ref={(el) => (inputrefs.current["txtEmail"] = el)}
                                                    type="email"
                                                    className="track-input"
                                                    placeholder="Enter email"
                                                    value={formData.email}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            inputrefs.current["txtPhoneNumber"]?.focus();
                                                        }
                                                    }}
                                                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                                />
                                            </div>
                                        </div>

                                        {/* Phone */}
                                        <div className="col-md-6">
                                            <div className="login-field mb-0">
                                                <label>Phone Number</label>
                                                <input id="txtPhoneNumber"
                                                    ref={(el) => (inputrefs.current["txtPhoneNumber"] = el)}
                                                    type="tel"
                                                    className="track-input"
                                                    placeholder="Enter phone number"
                                                    value={formData.phoneNo}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            inputrefs.current["txtAddress"]?.focus();
                                                        }
                                                    }}
                                                    maxlength="10"
                                                    onChange={(e) => setFormData({ ...formData, phoneNo: convertToNumber(e.target.value) })}
                                                />
                                            </div>
                                        </div>

                                        {/* Address */}
                                        <div className="col-md-6">
                                            <div className="login-field mb-0">
                                                <label>Address<span className="text-danger">*</span></label>
                                                <input id="txtAddress"
                                                    ref={(el) => (inputrefs.current["txtAddress"] = el)}
                                                    type="text"
                                                    className="track-input"
                                                    placeholder="Enter address"
                                                    value={formData.address}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            inputrefs.current["txtCity"]?.focus();
                                                        }
                                                    }}
                                                    onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                                                />
                                            </div>
                                        </div>

                                        {/* City */}
                                        <div className="col-md-6">
                                            <div className="login-field mb-0">
                                                <label>City<span className="text-danger">*</span></label>
                                                <input id="txtCity"
                                                    ref={(el) => (inputrefs.current["txtCity"] = el)}
                                                    type="text"
                                                    className="track-input"
                                                    placeholder="Enter city"
                                                    value={formData.city}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            inputrefs.current["txtComments"]?.focus();
                                                        }
                                                    }}
                                                    onChange={(e) => setFormData({ ...formData, city: e.target.value })}
                                                />
                                            </div>
                                        </div>

                                        {/* Comments */}
                                        <div className="col-md-12">
                                            <div className="login-field mb-0">
                                                <label>Comments</label>
                                                <textarea
                                                    id="txtComments"
                                                    ref={(el) => (inputrefs.current["txtComments"] = el)}
                                                    className="track-input"
                                                    rows="3"
                                                    value={formData.comment}
                                                    placeholder="Enter your Comments"
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            inputrefs.current["txtEnterCode"]?.focus();
                                                        }
                                                    }}
                                                    onChange={(e) => setFormData({ ...formData, comment: e.target.value })}
                                                >
                                                </textarea>
                                            </div>
                                        </div>

                                        {/* Security Code Display */}
                                        <div className="col-md-6">
                                            <div className="login-field mb-0">
                                                <label className="fw-semibold text-danger">Security Code</label>
                                                <div className="d-flex align-items-center gap-2">
                                                    <div
                                                        className="px-3 py-2 border border-danger rounded bg-light text-danger fw-bold text-monospace"
                                                        style={{ letterSpacing: "4px" }}
                                                    >
                                                        {formData.captcha.split("").join(" ")}
                                                    </div>
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-danger btn-sm"
                                                        onClick={generateCaptcha}
                                                    >
                                                        <i className="fa fa-sync-alt"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Enter Code */}
                                        <div className="col-md-6">
                                            <div className="login-field mb-0">
                                                <label>Enter Code<span className="text-danger">*</span></label>
                                                <input id="txtEnterCode"
                                                    ref={(el) => (inputrefs.current["txtEnterCode"] = el)}
                                                    type="text"
                                                    className="track-input"
                                                    value={formData.enterCode}
                                                    placeholder="Enter security code"
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            inputrefs.current["txtPassword"]?.focus();
                                                        }
                                                    }}
                                                    onChange={(e) => setFormData({ ...formData, enterCode: e.target.value })}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                    <div className="d-flex gap-3">
                                        <button type="button" class="track-btn" onClick={handleSave}><i className="fa fa-sign-in-alt me-1"></i>  {loading ? "Sending..." : "Send"}  </button>
                                        <button type="button" class="login-btn" onClick={handleReset}><i className="fa fa-undo me-1"></i> Reset </button>
                                    </div>
                                </form>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* STATS STRIP */}
            <section className="stats-strip">
                <div className="container">
                    <div className="row g-0 text-center">

                        <div className="col-6 col-md-3 stat-item py-2">
                            <div className="stat-number">4.5L+</div>
                            <div className="stat-label">Packets / Month</div>
                        </div>

                        <div className="col-6 col-md-3 stat-item py-2">
                            <div className="stat-number">1000+</div>
                            <div className="stat-label">Cities Covered</div>
                        </div>

                        <div className="col-6 col-md-3 stat-item py-2">
                            <div className="stat-number">35+</div>
                            <div className="stat-label">Years Experience</div>
                        </div>

                        <div className="col-6 col-md-3 stat-item py-2">
                            <div className="stat-number">10K+</div>
                            <div className="stat-label">Happy Clients</div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Enquiry
